export const ROSTER = [
  {
    role: 'EXP LANE', num: '01', ign: 'TILTERTOM',
    name: 'Tom Reynolds', age: '34', kids: '2',
    kda: '4.2 / 3.8 / 9.1', rank: 'MYTHIC', rankNum: '412', sleep: '5.4h',
    diapers: '2.4 / game',
    note: 'TANK MAIN — WILL DIVE FOR YOU AND THEN ASK ABOUT THE PEDIATRICIAN'
  },
  {
    role: 'JUNGLE', num: '02', ign: 'JUNGLEGYM',
    name: 'Jay Okafor', age: '31', kids: '3',
    kda: '8.9 / 2.1 / 7.4', rank: 'MYTHIC', rankNum: '287', sleep: '4.1h',
    diapers: '3.1 / game',
    note: "FATHER OF THREE. JUNGLES LIKE HE'S LATE FOR PRE-SCHOOL DROP-OFF."
  },
  {
    role: 'MID LANE', num: '03', ign: 'MIDLIFECRYSIS',
    name: 'Marcus Greer', age: '36', kids: '1',
    kda: '6.5 / 4.2 / 8.8', rank: 'MYTHIC', rankNum: '501', sleep: '6.2h',
    diapers: '1.8 / game',
    note: "INSISTS HE'S NOT IN A CRISIS. THE NAME IS LITERAL."
  },
  {
    role: 'GOLD LANE', num: '04', ign: 'GOLDFARMER_PAPA',
    name: 'Greg Henriksen', age: '38', kids: '2',
    kda: '9.6 / 2.5 / 5.2', rank: 'MYTHIC', rankNum: '189', sleep: '5.8h',
    diapers: '1.2 / game',
    note: "OLDEST DAD ON THE ROSTER. FARMS LIKE HE'S PAYING FOR COLLEGE."
  },
  {
    role: 'ROAM', num: '05', ign: 'BURPER_69',
    name: 'Ben Choi', age: '33', kids: '1',
    kda: '2.1 / 4.8 / 14.6', rank: 'MYTHIC', rankNum: '623', sleep: '2.7h',
    diapers: '4.6 / game',
    note: 'NEWBORN AT HOME. PERMANENTLY ROAMING TOWARD THE FRIDGE.'
  }
];
